import { postData } from '../utils';

export type PostSearchLogRequest = {
  searchQuery: string;
  searchDrugNames: string[];
  userChoiceDrugName: string;
};

export type PostSearchLogResponse = {
  status: number;
};

const postSearchLog = async (
  requestObj: PostSearchLogRequest
): Promise<PostSearchLogResponse> => {
  const response = await postData(`search_log`, requestObj);
  return response;
};

export default postSearchLog;
